/**
 * Determines if local tracing is enabled.
 * Used by both instrumentation registration and API routes.
 */
export function isLocalTracingEnabled(): boolean {
  return (
    process.env.NEXT_PUBLIC_OTEL_TARGET === 'local' && !process.env.VERCEL_ENV
  );
}
